/* eslint-disable react/jsx-key */
import React, { useState, useContext, useEffect } from 'react'
import { strCol, dateTimeCol, numCol } from '@integec/grid-tools/lib/cols'
import { connect } from 'react-redux'
import moment from 'moment'
import R from 'ramda'
import CommonScreen from '../../../src/admin/component/CommonScreen'
import styled from 'styled-components'
import {
  getEnvConfig,
  getPermitActions,
  hasAccesPermits,
  getApiTargetInfo,
} from '../../../src/core'
import { DataContext, ErrorContext } from 'context'
import * as ScreenPermissions from '../../../src/core/EventActions'
import {
  getSolarPI10MinData,
  saveSolarPI10MinData,
  deleteSolarPI10MinData,
  solarPlantSelection,
  solarPiTagSelection,
} from '../../../src/api/pgads'
import { Button, DatePicker, Input, message, InputNumber, Select } from 'antd'
import {
  modifiedDateCol,
  modifierCol,
} from '../../../src/core/HeaderColTypeProps'
import { DATE_TIME_FORMAT_API } from '../../../src/enum'
import { Label } from '../../../src/core/screen-util'

export const getLabel = ({ style = {}, label, required }) => (
  <div>
    <Label style={{ display: 'inline', float: 'right', ...style }}>
      {label} :
    </Label>
    {required && (
      <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
        *
      </span>
    )}
  </div>
)

const CustomSelect = styled(Select)`
  .ant-select-selection--multiple {
    max-height: 120px; /* Adjust height as needed */
    overflow-y: auto; /* Enable scrolling when content overflows */
  }
`

const title = 'Solar PI Row Data 10min'

const PIRow10MinData = ({ envConfig, actionPermits, targetInfo }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [selectedDateRangePicker, setSelectedDateRagePicker] = useState([
    moment()
      .subtract(1, 'd')
      .startOf('d'),
    moment(),
  ])
  const [plantSelectionData, setPlantSelectionData] = useState([])
  const [piTagSelectionData, setPiTagSelectionData] = useState([])
  const {
    selectedSolarPlant,
    setSelectedSolarPlant: setPlantSelected,
  } = useContext(DataContext)
  const plantSelected = Array.isArray(selectedSolarPlant)
    ? selectedSolarPlant[0]
    : selectedSolarPlant
  const [piTagSelected, setPiTagSelected] = useState([])
  const { setError } = useContext(ErrorContext)
  const writePermision = hasAccesPermits({
    authGodMode: envConfig.authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.SOLAR_PI_ROW_DATA_WRITE],
    matchAny: true,
  })

  useEffect(
    _ => {
      // make sort plantName
      solarPlantSelection(targetInfo)({
        year: selectedDateRangePicker[0].format('YYYY'),
        month: selectedDateRangePicker[0].format('MM'),
      }).fork(setError, data => {
        const sd = R.sortBy(R.prop('plantName'), data)
        setPlantSelectionData(sd)
        if (!plantSelected && sd[0] && sd[0].plantId)
          setPlantSelected([sd[0].plantId])
      })
    },
    [
      targetInfo,
      selectedDateRangePicker,
      setError,
      plantSelected,
      setPlantSelected,
    ]
  )

  useEffect(
    _ => {
      if (plantSelected) {
        solarPiTagSelection(targetInfo)({
          plantId: plantSelected,
          frequency: ',10m,',
        }).fork(setError, data => {
          const sd = R.sortBy(R.prop('tagId'), data)
          setPiTagSelectionData(sd)
        })
      }
    },
    [plantSelected, setError, targetInfo]
  )
  // const CustomSelect =
  const screenCriteria = (s, p, u, onChange) => {
    return (
      <>
        <Select
          showSearch
          value={plantSelected}
          style={{ width: '250px', marginLeft: '10px' }}
          onChange={plantId => {
            setPlantSelected([plantId])
            setPiTagSelected([])
            onChange()
            //  clearData()
          }}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
        >
          {plantSelectionData.map(({ plantName, plantId }) => (
            <Select.Option key={plantId} value={plantId}>
              {plantName}
            </Select.Option>
          ))}
        </Select>
        <CustomSelect
          showSearch
          placeholder="Select pi tags"
          value={piTagSelected}
          style={{ width: '350px', marginLeft: '10px' }}
          onChange={plantId => {
            setPiTagSelected(plantId)
            onChange()
          }}
          mode="multiple"
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
        >
          {piTagSelectionData && piTagSelectionData.length > 0 && (
            <Select.Option key="ALL" value="ALL">
              All
            </Select.Option>
          )}
          {piTagSelectionData.map(({ tagId }) => (
            <Select.Option key={tagId} value={tagId}>
              {tagId}
            </Select.Option>
          ))}
        </CustomSelect>
        <DatePicker.RangePicker
          style={{ width: '240px', marginLeft: '10px' }}
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDateRangePicker}
          onChange={d => {
            setSelectedDateRagePicker(d)
            onChange()
            // retrieve({ dates: d })
          }}
        />
      </>
    )
  }

  const isValidDateRange = (
    dateRange,
    startDate,
    endDate,
    showMessage = true
  ) => {
    const isValid = endDate.diff(startDate, 'd') <= parseInt(dateRange || 7)
    if (!isValid && showMessage) {
      message.error(
        'Selected Date Range should not more than ' + dateRange + '  Days gap.'
      )
    }
    return isValid
  }

  const beforeRetrieveValidation = () => {
    if (piTagSelected.length === 0) {
      message.error('Please, Select PI Tags')
      return false
    }
    return isValidDateRange(
      7,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
  }

  const validateData = data => {
    const { gmtTime, tagId } = data
    const fieldError = []
    let isError = false

    if (!tagId?.trim()) {
      fieldError.push('PI Tag')
      isError = true
    }
    if (!gmtTime) {
      fieldError.push('GMT Time')
      isError = true
    }
    if (isError) {
      message.warn('Some of required field are null :' + fieldError.join(','))
    }
    return !isError
  }

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '100px 200px 100px 200px 100px 200px 100px 200px',
        gap: 10,
      }}
    >
      {/* <Label>Select Utility/Unit : </Label> */}
      {getLabel({ label: 'Tag Id', required: true })}
      <Input
        style={{ gridColumnEnd: 'span 3' }}
        value={insertData.tagId}
        onChange={e =>
          setInsertData({
            ...insertData,
            tagId: e.target.value,
          })
        }
      />
      {/* <Label label="GMT Time" required /> */}
      {getLabel({ label: 'Time', required: true })}
      <DatePicker
        style={{}}
        value={insertData.gmtTime && moment(insertData.gmtTime)}
        showTime={{
          format: 'h:mm',
          defaultValue: moment('00:00', 'HH:mm'),
        }}
        format="MM/DD/YYYY HH:mm"
        placeholder="Select DateTime"
        onChange={date => {
          setInsertData({
            ...insertData,
            gmtTime: date.format(DATE_TIME_FORMAT_API),
          })
        }}
        onOk={date => {
          setInsertData({
            ...insertData,
            gmtTime: date.format(DATE_TIME_FORMAT_API),
          })
        }}
      />
      {/* <Label label="Data Type" /> */}
      {getLabel({ label: 'Data Type' })}
      <Input
        // style={{ gridColumnEnd: 'span 2' }}
        value={insertData.dataType}
        onChange={e =>
          setInsertData({
            ...insertData,
            dataType: e.target.value,
          })
        }
      />
      {/* <Label label="Num Value" /> */}
      {getLabel({ label: 'Num Value' })}
      <InputNumber
        style={{ width: '200px' }}
        value={insertData.numValue}
        onChange={val =>
          setInsertData({
            ...insertData,
            numValue: val,
          })
        }
      />
      {/* <Label label="Char Value" /> */}
      {getLabel({ label: 'Char Value' })}
      <Input
        value={insertData.charValue}
        onChange={e =>
          setInsertData({
            ...insertData,
            charValue: e.target.value,
          })
        }
      />
      <Button
        type="primary"
        style={{ marginLeft: '20px' }}
        onClick={() => onAdd(true)}
      >
        Add
      </Button>
      <Button
        style={{ marginLeft: '20px' }}
        type="primary"
        onClick={() => onAdd(false)}
      >
        Add & Hide
      </Button>
      <Button style={{ marginLeft: '20px' }} type="danger" onClick={onCancel}>
        Cancel
      </Button>
    </div>
  )

  return [
    <CommonScreen
      title={title}
      titleProps={{ width: 250 }}
      isAdminScreen={false}
      header={PIRowDataHeaders}
      saveTask={saveSolarPI10MinData}
      retrieveTask={getSolarPI10MinData}
      deleteTask={deleteSolarPI10MinData}
      beforeRetrieveValidation={beforeRetrieveValidation}
      // altBy={d => d.unit}
      // autoRetrieve
      validateData={validateData}
      screenCriteria={screenCriteria}
      withCriteria={() => ({
        piTags: piTagSelected.includes('ALL') ? [] : piTagSelected,
        plantId: plantSelected,
        allPiTagSelected: piTagSelected.includes('ALL'),
        startDate: selectedDateRangePicker[0],
        endDate: selectedDateRangePicker[1],
      })}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      //   widthOffset={550}
      heightOffset={200}
      initialSortOptions={PIRowDataHeaders}
      withoutModify={!writePermision}
      allowInsert={writePermision}
      withDelete={writePermision}
      selectionType="cell"
      selectionMode="multi"
    />,
  ]
}

const mapStateToProps = state => ({
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(PIRow10MinData)

export const PIRowDataHeaders = [
  strCol({
    ident: 'tagId',
    display: 'Tag Id',
    width: 400,
    isFiltered: true,
    isKey: true,
    alignment: 'left',
    sortOrder: 'asc',
  }),
  dateTimeCol({
    ident: 'gmtTime',
    display: 'GMT Time',
    isKey: true,
    sortOrder: 'asc',
    width: 200,
  }),
  strCol({
    ident: 'localTime',
    display: 'Local Time',
    sortOrder: 'asc',
    isFiltered: true,
    width: 200,
    // alignment: 'left',
    // isKey: true,
    isEditable: false,
  }),
  strCol({
    ident: 'dataType',
    display: 'Data Type',
    sortOrder: 'asc',
    isFiltered: true,
    width: 200,
    alignment: 'left',
  }),
  numCol({
    ident: 'numValue',
    display: 'Num Value',
    precision: 3,
    isFiltered: true,
  }),
  strCol({
    ident: 'charValue',
    display: 'Char Value',
    isFiltered: true,
  }),
  modifierCol,
  modifiedDateCol,
].map(d => ({ ...d, ellipsis: true }))
